import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";

import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";

function LineasCreate() {
  const { user } = useContext(AuthContext);
  const URL_LINEAS = process.env.REACT_APP_URL_LINEAS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [name, setName] = useState("");
  const [factor1, setFactor1] = useState(0);
  const [factor2, setFactor2] = useState(0);
  const [factor3, setFactor3] = useState(0);
  const [factor4, setFactor4] = useState(0);
  const [text, setText] = useState(false);
  const [validaBoton, setValidaBoton] = useState(true);

  const clear = () => {
    setName("");
  };

  const saveLineas = (event) => {
    event.preventDefault();
    setValidaBoton(false);
    axios
      .post(
        URL_LINEAS,
        {
          name,
          factor1,
          factor2,
          factor3,
          factor4,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Crear Linea",
            detalle: name,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        clear();
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  };

  return (
    <>
      <div className="container">
        <h3 align="center">Crea una linea</h3>
        <Form onSubmit={saveLineas}>
          <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
          <Row>
            <Label for="exampleEmail" className="mr-sm-2">
              Linea
            </Label>
            <Input
              type="text"
              name="email"
              id="exampleEmail"
              placeholder="Nombre de la Linea"
              value={name}
              required
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
            </Row>
            {/* <Row>
              <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Factor 1
                </Label>
                <Input
                  type="number"
                  placeholder="Factor 1"
                  value={factor1}
                  required
                  onChange={(e) => {
                    setFactor1(e.target.value);
                  }}
                />
              </Col>
              <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Factor 2
                </Label>
                <Input
                  type="number"
                  placeholder="Factor 2"
                  value={factor2}
                  required
                  onChange={(e) => {
                    setFactor2(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Factor 3
                </Label>
                <Input
                  type="number"
                  placeholder="Factor 3"
                  value={factor3}
                  required
                  onChange={(e) => {
                    setFactor3(e.target.value);
                  }}
                />
              </Col>
              <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Factor 4
                </Label>
                <Input
                  type="number"
                  placeholder="Factor 4"
                  value={factor4}
                  required
                  onChange={(e) => {
                    setFactor4(e.target.value);
                  }}
                />
              </Col>
            </Row> */}
          </FormGroup>
          <Row className="container">
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <div>
              <SweetAlert
                show={text}
                title="Creado con Exito"
                onConfirm={() => {
                  setText(false);
                }}
              />
            </div>
            <Button color="danger" href="/MenuArticulos">
              Regresar
            </Button>
            </Row>
        </Form>
      </div>
    </>
  );
}

export default LineasCreate;
